// AUTO-GENERATED — part 2 of packages/shared/src/index.ts (split-large-files.mjs)
import type {
  ThinkingLevel,
  GenerationParameters,
  Message,
  TodoListSnapshot,
} from "./_shared.js";
import type { ProjectMember } from "./project-member.js";
import type { GoalSnapshot } from "../goals.js";

export const CONVERSATION_MESSAGE_PAGE_SIZE = 6;

export interface Conversation {
  id: string;
  title: string;
  modelId: string | null;
  shared?: boolean;
  rootConversationId: string | null;
  forkedFromMessageId: string | null;
  activeLeafMessageId: string | null;
  activeGenerationMessageId?: string | null;
  lastSeenMessageId?: string | null;
  agentId: string | null;
  groupId: string | null;
  surface?: "chat" | "project";
  composerDefaults?: Record<string, unknown>;
  pinned: boolean;
  temporary?: boolean;
  createdAt: string;
  updatedAt: string;
  generationStatus?: Message["generationStatus"] | null;
  attention?: "action-required" | "response-ready" | null;
  attentionMessageId?: string | null;
  todoList?: TodoListSnapshot | null;
  goal?: GoalSnapshot | null;
  messages?: Message[];
  hasMoreMessages?: boolean;
  nextMessageCursor?: string | null;
}

export interface ConversationGroup {
  id: string;
  name: string;
  createdAt: string;
  updatedAt: string;
}

export interface Project {
  id: string;
  name: string;
  description: string | null;
  visibility: "private" | "organization";
  defaultActivity: GenerationParameters["activity"];
  composerDefaults: {
    toolIds?: string[];
    artifactIds?: string[];
    skillIds?: string[];
    mcpServerIds?: string[];
    mcpToolSelections?: Record<string, string[]>;
    agentWorkspaceId?: string | null;
    repositoryId?: string | null;
    agentWorkspaceIds?: string[];
    repositoryIds?: Record<string, string[]>;
    agentId?: string | null;
    thinkingLevel?: ThinkingLevel;
    generationParameters?: GenerationParameters;
  };
  ownerUserId?: string;
  expanded?: boolean;
  createdAt: string;
  updatedAt: string;
  members?: ProjectMember[];
}
